import { z } from "zod";

// Shared optional-email validation: a value is validated as a proper email
// when present, but an empty string is allowed since the field itself is
// optional on the backend. Reused wherever a "notify/reply to this email"
// style field appears outside the CRM forms (see crm-validation.ts for the
// CRM-specific equivalent, `crmFieldValidations.onsiteContactEmail`).
export const optionalEmailSchema = z.union([
  z.string().email("Invalid email"),
  z.literal(""),
]);
